// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ListItemIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ListItemIcon" ref={forwardedRef} {...props}>
      <path d="M3.25 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" />
      <path d="M18 9.252H6.5v1.498H18z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ListItemIcon = /* @__PURE__ */ Object.assign(
  ListItemIconComponent,
  { displayName: 'ListItemIcon' },
);
